import { render, staticRenderFns } from "./ShoppingItem.vue?vue&type=template&id=4c3f5e34&"
import script from "./ShoppingItem.vue?vue&type=script&lang=js&"
export * from "./ShoppingItem.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports